import {getEventId, getFormattedLocation} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../commons/hooks/dates'
import {useWidgetState} from '../../hooks/state-provider'
import {getAlignmentClassName} from '../../selectors/classes'
import {getCompactDateAndLocationMargin, isCompactDateAndLocationVisible} from '../../selectors/single-settings'
import sc from '../classes.scss'
import {ShortDateLocationProps} from './interfaces'
import s from './short-date-location.scss'

export const SingleEventShortDateLocation = ({
  event,
  alignment,
  showDate,
  showLocation,
  onImage,
}: ShortDateLocationProps) => {
  const dateAndLocationVisible = useWidgetState(isCompactDateAndLocationVisible)
  const marginBottom = useWidgetState(getCompactDateAndLocationMargin)
  const {startDate} = useEventDateInformation(getEventId(event))

  return dateAndLocationVisible ? (
    <div
      className={classNames(
        onImage ? s.onImageCompactTextsFont : s.compactTextsFont,
        s.singleEventContainer,
        sc.textLineHeight,
        s[getAlignmentClassName(alignment)],
        {
          [s.noDate]: !showDate,
          [s.noLocation]: !showLocation,
        },
      )}
      data-hook="ev-short-date-location"
      style={{marginBottom}}
    >
      <div className={s.dateWrapper}>
        <div className={s.date} data-hook="short-date">
          {startDate}
        </div>
        <div className={s.divider} />
      </div>
      <div className={s.location} data-hook="short-location">
        {getFormattedLocation(event)}
      </div>
    </div>
  ) : null
}
